import { forwardRef } from '@chakra-ui/react';
import React from 'react';

import { Heading, HeadingProps } from '../Heading/Heading';

export interface DrawerTitleProps
  extends Omit<HeadingProps<'h2'>, 'size' | 'variant' | '__orbitStyleConfig'> {
  size?: 'auto' | 'fill';
}

export const DrawerTitle = forwardRef<DrawerTitleProps, 'h2'>(
  ({ size = 'auto', ...props }, ref) => {
    return (
      <Heading
        {...props}
        ref={ref}
        size="xl"
        __orbitStyleConfig={{
          flex: size === 'fill' ? 1 : undefined,
        }}
      />
    );
  },
);
